module.exports = __webpack_public_path__ + "static/templogo-9061ea0ffafa3c2e7ecbee343d666c23.png";